import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useLang } from "@/lib/i18n";
import { inputCls, selectCls } from "@/lib/forms";
import { packageOptions } from "@/data/catering";

const Field = ({ id, label, required, children }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-hacienda-charcoal font-medium">{label}{required && " *"}</Label>
    {children}
  </div>
);

const Select = ({ id, name, value, onChange, options, required, testId, placeholder }) => (
  <select id={id} name={name} required={required} value={value} onChange={onChange} className={selectCls} data-testid={testId}>
    <option value="">{placeholder}</option>
    {options.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
  </select>
);

export const QuoteFields = ({ form, onChange }) => {
  const { t } = useLang();
  const f = (k) => t(`catering.f.${k}`);
  const asOptions = (arr) => arr.map((o) => [o, o]);
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-5">
        <Field id="q-name" label={f("name")} required><Input id="q-name" name="name" required autoComplete="name" value={form.name} onChange={onChange} className={inputCls} data-testid="quote-name-input" /></Field>
        <Field id="q-phone" label={f("phone")} required><Input id="q-phone" name="phone" type="tel" required autoComplete="tel" inputMode="tel" value={form.phone} onChange={onChange} className={inputCls} data-testid="quote-phone-input" /></Field>
        <Field id="q-email" label={f("email")} required><Input id="q-email" name="email" type="email" required autoComplete="email" value={form.email} onChange={onChange} className={inputCls} data-testid="quote-email-input" /></Field>
        <Field id="q-date" label={f("eventDate")} required><Input id="q-date" name="eventDate" type="date" required value={form.eventDate} onChange={onChange} className={inputCls} data-testid="quote-date-input" /></Field>
        <Field id="q-type" label={f("eventType")} required>
          <Select id="q-type" name="eventType" required value={form.eventType} onChange={onChange} options={asOptions(t("catering.eventTypes"))} placeholder={f("select")} testId="quote-eventtype-select" />
        </Field>
        <Field id="q-guests" label={f("guestCount")} required><Input id="q-guests" name="guestCount" type="number" min="1" inputMode="numeric" required value={form.guestCount} onChange={onChange} className={inputCls} data-testid="quote-guests-input" /></Field>
        <Field id="q-service" label={f("serviceType")} required>
          <Select id="q-service" name="serviceType" required value={form.serviceType} onChange={onChange} options={[["Pickup", f("pickup")], ["Delivery", f("delivery")]]} placeholder={f("select")} testId="quote-service-select" />
        </Field>
        <Field id="q-venue" label={f("venue")}><Input id="q-venue" name="venueOrZip" autoComplete="postal-code" value={form.venueOrZip} onChange={onChange} className={inputCls} data-testid="quote-venue-input" /></Field>
        <Field id="q-pkg" label={f("pkg")}>
          <Select id="q-pkg" name="desiredPackage" value={form.desiredPackage} onChange={onChange} options={asOptions(packageOptions)} placeholder={f("select")} testId="quote-package-select" />
        </Field>
        <Field id="q-budget" label={f("budget")}><Input id="q-budget" name="budget" placeholder="$" value={form.budget} onChange={onChange} className={inputCls} data-testid="quote-budget-input" /></Field>
      </div>
      <Field id="q-info" label={f("info")}><Textarea id="q-info" name="additionalInfo" rows={4} value={form.additionalInfo} onChange={onChange} className="bg-white border-hacienda-border-light focus-visible:ring-hacienda-terracotta resize-none" data-testid="quote-info-input" /></Field>
      <Field id="q-hear" label={f("hear")}>
        <Select id="q-hear" name="hearAbout" value={form.hearAbout} onChange={onChange} options={asOptions(t("catering.hearOptions"))} placeholder={f("select")} testId="quote-hear-select" />
      </Field>
    </>
  );
};
